import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { PontoFisicoService } from '../ponto-fisico.service';
import { ComumService } from '../../comum/comum.service';
import { TipoPontoFisico } from '../../comum/modelos/tipo-ponto-fisico';
import { CookieService } from 'angular2-cookie/core';

@Component({
  selector: 'app-cadastro-tipo-ponto-fisico',
  templateUrl: './cadastro-tipo-ponto-fisico.component.html',
  styleUrls: ['./cadastro-tipo-ponto-fisico.component.css']
})
export class CadastroTipoPontoFisicoComponent implements OnInit {

  @Output() tipoPontoFisicoEvent: EventEmitter<TipoPontoFisico>;

  tipoPontoFisico: TipoPontoFisico;

  statusCode: number;
  public loading = false;

  constructor(
    private _pontoFisicoService: PontoFisicoService,
    private _comumService: ComumService,
    private _cookieService: CookieService) {
    this.tipoPontoFisico = new TipoPontoFisico();
    this.tipoPontoFisicoEvent = new EventEmitter<TipoPontoFisico>();
  }

  ngOnInit() {
  }

  onSubmit(): void {
    this.loading = true;
    this.tipoPontoFisico.idCliente = parseInt(this._cookieService.get('idCliente'));
    this._pontoFisicoService.inserirTipoPontoFisicoHttp(this.tipoPontoFisico)
      .subscribe(response => {
        this.loading = false;
        this.statusCode = response.status;
        this._comumService.evento.cadastro = true;
        this.tipoPontoFisicoEvent.emit(response.body);
      }, errorCode => {
        this.statusCode = errorCode;
        this.loading = false;
      });
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ponto-fisico/cadastro-tipo-ponto-fisico/cadastro-tipo-ponto-fisico.component.ts